// extracted by css-extract-rspack-plugin
export default {"QueryBuilderViewRoot":"_vnGb","QueryBuilderContentContainer":"wAs_Z"};